import React from 'react';

import cn from 'classnames';
import isArray from 'lodash/isArray';

import bem from 'client/services/bem';

import {Translation} from 'client/models/language/types';

import cssModule from './error-message.module.scss';

const b = bem('error-message', {cssModule});

export type ErrorMessageType = Translation | Translation[];

type Props = {
  className?: string;
  errorMessage?: ErrorMessageType;
};

const ErrorMessage: React.FC<Props> = (props) => {
  const {className = '', errorMessage} = props;

  return (
    <div className={cn(b(), className)}>
      {isArray(errorMessage) && errorMessage.length !== 0 ? (
        <ul className={b('list')}>
          {errorMessage.map((error, idx) => (
            <li key={idx} className={b('message')}>
              {error}
            </li>
          ))}
        </ul>
      ) : (
        <p className={b('message')}>{errorMessage}</p>
      )}
    </div>
  );
};

export default ErrorMessage;
